import { format, isToday } from 'date-fns';

export const formatDateTimeLocal = (
	date: any,
	timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
) => {
	if (!date) return '';

	const d = new Date(date);
	if (isNaN(d.getTime())) return '';

	return new Intl.DateTimeFormat('sv-SE', {
		timeZone,
		hour12: false,
		year: 'numeric',
		month: '2-digit',
		day: '2-digit',
		hour: '2-digit',
		minute: '2-digit',
	})
		.format(d)
		.replace(' ', 'T');
};

export const formatLocalDateTime = (isoString: any) => {
	const d = new Date(isoString);

	const monthNames = [
		'January',
		'February',
		'March',
		'April',
		'May',
		'June',
		'July',
		'August',
		'September',
		'October',
		'November',
		'December',
	];

	const month = monthNames[d.getMonth()];
	const day = d.getDate();
	const year = d.getFullYear();

	let hours = d.getHours();
	const minutes = String(d.getMinutes()).padStart(2, '0');
	const ampm = hours >= 12 ? 'PM' : 'AM';

	hours = hours % 12;
	hours = hours ? hours : 12;
	return `${month} ${day}, ${year} ${hours}:${minutes} ${ampm}`;
};

export const isValidDate = (value: any) => {
	if (!value) return false;
	const date = new Date(value);
	return date instanceof Date && !isNaN(date.getTime());
};

export const formatDateTimeFull = (date: any) => {
	const formattedDate = new Date(date);
	const year = formattedDate.getUTCFullYear();
	const month = String(formattedDate.getUTCMonth() + 1).padStart(2, '0');
	const day = String(formattedDate.getUTCDate()).padStart(2, '0');
	const hours = String(formattedDate.getUTCHours()).padStart(2, '0');
	const minutes = String(formattedDate.getUTCMinutes()).padStart(2, '0');
	const seconds = String(formattedDate.getUTCSeconds()).padStart(2, '0');

	return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
};

export const getCurrentTimestamp = () => formatDateTimeFull(Date.now());

export const formatTimeToAmPm = (date: any, { trimLeadingZero = false } = {}) => {
	const d = new Date(date);

	let hours = d.getHours();
	const minutes = String(d.getMinutes()).padStart(2, '0');
	const ampm = hours >= 12 ? 'PM' : 'AM';

	hours = hours % 12;
	hours = hours === 0 ? 12 : hours;

	const hoursStr = trimLeadingZero ? String(hours) : String(hours).padStart(2, '0');
	return `${hoursStr}:${minutes}${ampm}`;
};

export function toISOString(date: any) {
	if (!date) return null;
	const parsed = typeof date === 'string' ? new Date(date) : date;
	return parsed instanceof Date && !isNaN(parsed.getTime()) ? parsed.toISOString() : null;
}

export const formatDisplayDate = (date: any) => {
	if (!date) return '';
	const d = new Date(date);
	if (isNaN(d.getTime())) return '';

	return d.toLocaleString(undefined, {
		year: 'numeric',
		month: 'short',
		day: 'numeric',
		hour: '2-digit',
		minute: '2-digit',
	});
};

export const formatMessageTime = (created_date: string | Date | null | undefined) => {
	if (!created_date) return null;

	const date = new Date(created_date);

	return isToday(date) ? format(date, 'h:mm a') : format(date, 'MM.dd.yy h:mm a');
};
